import * as AutoKana from 'vanilla-autokana'

window.AutoKana = AutoKana

require('packs/commons/validation')

window.onpageshow = function () {
  $('#js-inquire-form').get(0).reset();
};

$(function () {
  $(document).on('input', '.js-postal-code-autocomplete', function () {
    const postalCode = $(this).val().replaceAll('-', '');
    if (postalCode.length <= 6) {
      return;
    }

    const parent = $(this).parents('.js-addresses-area');

    new YubinBango.Core(postalCode, function (address) {
      parent.find('.js-prefecture').val(address.region).blur();
      parent.find('.js-city').val(address.locality + address.street).blur();
    });
  });

  const nameAreas = $('.js-name-area')
  if (nameAreas.length > 0) {
    nameAreas.each(function (index, nameArea) {
      AutoKana.bind('#' + $(nameArea).find('.js-last-name').attr('id'), '#' + $(nameArea).find('.js-last-name-kana').attr('id'), {katakana: true});
      AutoKana.bind('#' + $(nameArea).find('.js-first-name').attr('id'), '#' + $(nameArea).find('.js-first-name-kana').attr('id'), {katakana: true});
    });
  }

  if (inquiryLocale === 'ja') {
    $(document).on('change', '.js-last-name,.js-first-name,.js-last-name-kana,.js-first-name-kana', function () {
      const parent = $(this).parents('.js-content-row');
      const displayOrder = parent.data('display-order');
      const fullName = parent.find('.js-last-name').val() + '　' + parent.find('.js-first-name').val();
      const fullNameKana = parent.find('.js-last-name-kana').val() + '　' + parent.find('.js-first-name-kana').val();
      $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text(fullName + "\n" + fullNameKana);
    });
  } else {
    $(document).on('change', '.js-last-name,.js-first-name,.js-middle-name', function () {
      const parent = $(this).parents('.js-content-row');
      const displayOrder = parent.data('display-order');
      const middleName = parent.find('.js-middle-name').val();
      const fullName = parent.find('.js-first-name').val() + (middleName ? ' ' + middleName : '') + ' ' + parent.find('.js-last-name').val();
      $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text(fullName);
    });
  }

  $(document).on('change', '.js-email,.js-tel,.js-text-input,.js-textarea-input,.js-number-input,.js-select', function () {
    const parent = $(this).parents('.js-content-row');
    const displayOrder = parent.data('display-order');
    $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text($(this).val());
  });

  $(document).on('change', '.js-country', function () {
    const parent = $(this).parents('.js-content-row');
    const displayOrder = parent.data('display-order');
    $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text($(this).find('option:selected').text());
  });

  $(document).on('change', '.js-postal-code,.js-prefecture,.js-city,.js-address-block,.js-building-room-number', function () {
    const parent = $(this).parents('.js-content-row');
    const displayOrder = parent.data('display-order');
    const postalCode = (inquiryLocale === 'ja' ? '〒' : '') + parent.find('.js-postal-code').val();
    const address = parent.find('.js-prefecture').val() + parent.find('.js-city').val() + parent.find('.js-address-block').val() + parent.find('.js-building-room-number').val();
    $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text(postalCode + "\n" + address);
  });

  $(document).on('change', '.js-birth-year,.js-birth-month,.js-birth-day', function () {
    const parent = $(this).parents('.js-content-row');
    const displayOrder = parent.data('display-order');
    let birth = '';
    if (inquiryLocale === 'ja') {
      birth = parent.find('.js-birth-year').val() + '年' + parent.find('.js-birth-month').val() + '月' + parent.find('.js-birth-day').val() + '日';
    } else {
      birth = parent.find('.js-birth-day').val() + '/' + parent.find('.js-birth-month').val() + '/' + parent.find('.js-birth-year').val();
    }
    $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text(birth);
  });

  $('.js-input:not([value=""])').change();

  $(document).on('change', '.js-donate-check,.js-donation-amount-input', function () {
    const parent = $(this).parents('.js-content-row');
    const displayOrder = parent.data('display-order');
    let totalAmount = 0;
    const donates = parent.find('.js-donate-check:checked').map(function () {
      let amount = $(this).siblings('.js-donate-input').find('.js-donation-amount-input').val();
      if (!amount) {
        amount = '0';
      }
      let amountInt = parseInt(amount);
      totalAmount += amountInt;
      return $(this).siblings('.js-donate-label').text() + '　' + amountInt.toLocaleString() + '円';
    }).get();
    if (totalAmount > 0) {
      donates.push('合計　' + totalAmount.toLocaleString() + '円');
    }
    $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text(donates.join("\n"));
  });

  $('.js-donate-check:checked').change();

  $(document).on('change', '.js-check', function () {
    const parent = $(this).parents('.js-content-row');
    const displayOrder = parent.data('display-order');
    const checks = parent.find('.js-check:checked').map(function () {
      return $(this).siblings('.js-check-label').text();
    }).get();
    $('.js-content-confirm-row.content-' + displayOrder + ' .js-confirm-text').text(checks.join("\n"));
  });

  $(document).on('change', '.js-privacy-policy', function () {
    const agreement = $(this).prop('checked');
    if (agreement) {
      $('.js-confirm-privacy-policy-text .js-confirm-privacy-policy-text-agree').show();
      $('.js-confirm-privacy-policy-text .js-confirm-privacy-policy-text-not-agree').hide();
    } else {
      $('.js-confirm-privacy-policy-text .js-confirm-privacy-policy-text-agree').hide();
      $('.js-confirm-privacy-policy-text .js-confirm-privacy-policy-text-not-agree').show();
    }
  });

  $(document).on('change', '.js-select', function () {
    const value = $(this).val();
    const key = $(this).data('key');
    $('.js-content-row').each(function (index, row) {
      if ($(row).data('required-condition-key') === key) {
        if ($(row).data('required-condition-value') === value) {
          $(row).find('.js-label:not(.js-address4-label)').removeClass('c-form-label--optional').addClass('c-form-label--required');
        } else {
          $(row).find('.js-label:not(.js-address4-label)').removeClass('c-form-label--required').addClass('c-form-label--optional');
        }
      }
      if ($(row).data('display-condition-key') === key) {
        const displayOrder = $(row).data('display-order');
        const confirmRow = $('.js-content-confirm-row.content-' + displayOrder);
        if ($(row).data('display-condition-value') === value) {
          $(row).show();
          $(row).find('input:not([name*=answer_for_check]):not(.js-donation-amount-input),textarea,select').prop('disabled', false);
          confirmRow.show();
        } else {
          $(row).hide();
          $(row).find('input:not([type=hidden]),textarea,select').prop('disabled', true);
          $(row).find('input[type=checkbox]').prop('checked', false);
          $(row).find('input[type=checkbox]').change();
          $(row).find('select').val('');
          $(row).find('select').change();
          confirmRow.hide();
        }
      }
    });
    // jquery-validationで必須条件チェック用hiddenに値を格納
    $(this).parents('.js-content-row').find('.js-select-for-check').val('"' + value + '"');
  });

  $('.js-select').change();

  $(document).on('change', '.js-check', function () {
    const value = $(this).val();
    const key = $(this).data('key');
    const checked = $(this).prop('checked');
    $('.js-content-row').each(function (index, row) {
      if ($(row).data('required-condition-key') === key && $(row).data('required-condition-value') === value) {
        if (checked) {
          $(row).find('.js-label:not(.js-address4-label)').removeClass('c-form-label--optional').addClass('c-form-label--required');
        } else {
          $(row).find('.js-label:not(.js-address4-label)').removeClass('c-form-label--required').addClass('c-form-label--optional');
        }
      }
      if ($(row).data('display-condition-key') === key && $(row).data('display-condition-value') === value) {
        const displayOrder = $(row).data('display-order');
        const confirmRow = $('.js-content-confirm-row.content-' + displayOrder);
        if (checked) {
          $(row).show();
          $(row).find('input:not([name*=answer_for_check]):not(.js-donation-amount-input),textarea,select').prop('disabled', false);
          confirmRow.show();
        } else {
          $(row).hide();
          $(row).find('input:not([type=hidden]),textarea,select').prop('disabled', true);
          $(row).find('input[type=checkbox]').prop('checked', false);
          $(row).find('input[type=checkbox]').change();
          $(row).find('select').val('');
          $(row).find('select').change();
          confirmRow.hide();
        }
      }
    });
    // jquery-validationで必須条件チェック用hiddenに値を格納
    let checkedValues = '';
    $(this).parents('.js-content-row').find('input[type=checkbox]:checked').each(function (index, check) {
      checkedValues += '"' + $(check).val() + '"';
    });
    $($(this).parents('.js-content-row').find('.js-select-for-check').val(checkedValues));
  });

  $('.js-check').change();

  $(document).on('change', '.js-donate-check', function () {
    const input = $(this).siblings('.js-donate-input');
    if ($(this).prop('checked')) {
      input.removeClass('hidden');
      input.find('input').prop('disabled', false);
    } else {
      input.addClass('hidden');
      input.find('input').val('').removeClass('c-form-error').prop('disabled', true);
      $(this).parent().siblings('.js-error-label').hide();
    }
    calcAmounts($(this).parents('.js-content-row'));
  });

  $(document).on('change', '.js-donate-input', function () {
    calcAmounts($(this).parents('.js-content-row'));
  });

  $('.js-donate-check').change();

  $(document).on('change', '.js-country', function () {
    const value = $(this).val();
    // jquery-validationで必須条件チェック用hiddenに値を格納
    $(this).parents('.js-content-row').find('.js-country-for-check').val('"' + value + '"');
  });

  $('.js-country').change();

  function calcAmounts(jsContentRow) {
    const donateInputs = $(jsContentRow).find('.js-donate-input:not(.hidden) input');
    let totalAmount = 0;
    donateInputs.each(function (index, row) {
      let value = $(row).val();
      if (value) {
        totalAmount += parseInt(value);
      }
    });
    $(jsContentRow).find('.js-total-amount').text(totalAmount.toLocaleString());
  }

  $(document).on('click', '#js-confirm-button', function () {
    if ($('#js-inquire-form').valid()) {
      $(window).scrollTop(0);
      $('#js-input-area').hide();
      $('#js-confirm-area').show();
    } else {
      // エラーを画面中央に持ってくる
      $(window).scrollTop($('label.c-form-error:visible:first').offset().top - ($(window).height() / 2));
    }
  });

  // 送信ボタン
  $(document).on('click', '#js-submit-button', async function () {
    $('#js-submit-button').prop('disabled', true);
    // reCAPTCHAのトークン更新
    const tokenInput = $('#g-recaptcha-response-data-inquiry');
    if (tokenInput) {
      const token = await window.executeRecaptchaForInquiryAsync();
      tokenInput.val(token);
    }
    $('#js-inquire-form').submit();
  });

  $(document).on('click', '#js-back-button', function () {
    $(window).scrollTop(0);
    $('#js-confirm-area').hide();
    $('#js-input-area').show();
  });

  $('#js-inquire-form').validate({
    errorClass: 'c-form-error',
    ...jquery_validation_values
  });
});
